<template>
  <NuxtLink
    :to="to"
    class="relative flex w-full flex-row items-center gap-3.5 px-5 text-[18px]"
    :class="isActive ? 'text-orange' : 'text-white'"
  >
    <component
      :is="IconComponent"
      width="24"
      height="24"
      fill="currentColor"
      class="block h-6 w-6 flex-shrink-0"
    />
    <slot class="font-helvetica font-norma" />
    <div
      v-show="isActive"
      class="absolute right-0 h-[36px] w-[4px] rounded-[25px] bg-orange"
    ></div>
  </NuxtLink>
</template>

<script setup lang="ts">
import ContactIcon from "~/assets/svg/menu/contact.svg?component";
import DeliveryIcon from "~/assets/svg/menu/delivery.svg?component";
import GoodsIcon from "~/assets/svg/menu/goods.svg?component";
import HomeIcon from "~/assets/svg/menu/home.svg?component";
import LogistIcon from "~/assets/svg/menu/logist.svg?component";
import FinanceIcon from "~/assets/svg/menu/finance.svg?component";
import OrderIcon from "~/assets/svg/menu/order.svg?component";
import SettingsIcon from "~/assets/svg/menu/settings.svg?component";

const iconComponents = {
  "m-icon:home": HomeIcon,
  "m-icon:goods": GoodsIcon,
  "m-icon:order": OrderIcon,
  "m-icon:finance": FinanceIcon,
  "m-icon:delivery": DeliveryIcon,
  "m-icon:logist": LogistIcon,
  "m-icon:contact": ContactIcon,
  "m-icon:settings": SettingsIcon,
} as const;

const props = defineProps<{
  to: string;
  icon: keyof typeof iconComponents;
}>();

const route = useRoute();
// Highlight as active when current path matches or is nested under the target path
const isActive = computed(() => route.path === props.to || route.path.startsWith(`${props.to}/`));

const IconComponent = computed(() => iconComponents[props.icon] ?? HomeIcon);
</script>
